<template>
    <div class="bc-box">
        <div class="bc-header">
            <span class="bc-title">淘宝短链接</span>
            <span class="bc-cont">
                <el-alert title="提示：输入需要的商品信息--------------------------选择专属域名--------------------------生成短连接" type="warning" :closable="false" show-icon></el-alert>
            </span>
        </div>
        <div class="bc-main box-sizing">


            <div class="mid-btn-box">

                <div class="show22_box" style="height:700px;overflow-y: scroll;width:500px;float: left;">
                    <div class="mb-10">
                        顶部标题：
                        <div>
                            <input type="text"  style="width:300px;" class="el-input__inner glist_title" value="宝贝分享"/>
                        </div>
                    </div>
                    <div class="show22" style="border:1px solid #eee;margin-top:15px; padding:20px;margin-bottom: 10px;background:#f5f5f5">
                        <div style="padding:10px;font-weight: bold;font-size:20px;margin-bottom: 20px;">商品 <a onclick="delGoods(this)" style="display: none;float: right;color:#0000ff;" class="del_btn011">删除</a></div>

                        <div class="mb-10">
                            淘宝链接：
                            <div>
                                <input type="text"  class="el-input__inner glist_tb_url" style="width:380px;"/>
                                <a style="color:#0000ff;" onclick="getTbinfo(this)"> 自动提取</a>
                            </div>
                            <div style="color:red;">*输入淘宝详情页、商品id、优惠券链接</div>

                        </div>
                        <div class="mb-10">
                            图片地址：
                            <div>
                                <input type="text"  class="el-input__inner glist_img"/>
                            </div>
                            <div style="color:red;">*禁止上传色情赌博等非法图片</div>

                        </div>
                        <div class="mb-10">
                            显示和复制的文字：
                            <div>
                            <textarea class="glist_desc" cols="30" rows="10" style="width:90%;border-radius: 4px; border: 1px solid #DCDFE6;"></textarea>
                            </div>
                        </div>
                        <div class="mb-10">
                            淘口令：
                            <div>
                                <input type="text"  style="width:200px;" class="el-input__inner glist_kouling"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="float: right;width:310px;">
                    <div style="font-weight: bold;padding:10px;"><a  @click="yulan()" style="color:#0000ff;">点击预览</a></div>

                    <div class="goods_tpl_box">
                        <div class="goods_tpl_title" >顶部标题</div>
                        <div class="goods_tpl_parent">
                            <div class="goods_tpl_tpl">

                                <div  class="goods_tpl_img_box"><img src="https://img-browser.ttdwz.cc/wm/uploadfile/2020/10/31/NMCsPKPkwp.jpg" style="width:100%;"></div>
                                <div class="goods_tpl_desc">
                                    【X瓶】xxxxxxxxxxxxxx <br>
                                    ❥原价xx.xx<br>
                                    ❥跟我买【x.xx】<br>
                                    ---------<br>
                                    (xxxxxxxxxxx)<br>
                                    復製本条消息打开手机寳即可<br>

                                </div>
                                <div type="button" class="icopy" id="icopy" onclick="copy_tkl1(this, 1)" data-clipboard-text="1【2瓶】凡士林防冻裂润肤护手霜❥原价19.90❥跟我买【9.90】————————(Zbq4cipWiOP)復製本条消息打开手机寳即可:/">一键复制</div>
                                <div id="copy-tip" class="copy-tip">
                                    <span>长按框内</span>
                                    <span class="jtone"></span>
                                    <span>全选</span>
                                    <span class="jttwo"></span>
                                    <span>复制</span>
                                    <span class="jtthree"></span>
                                    <span><img src="https://pic.kuaizhan.com/g3/ba/35/9ec3-520f-471d-834b-6410aa24ef0315" style="width: 18px;vertical-align: middle;">打开手机Tao宝</span>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <div style="clear: both;"></div>


                <div class="mb-10"><a  style="color:#0000ff;" @click="addGoods()"> + 增加商品</a></div>



                <div class="mb-10">
                    选择专属域名：
                    <el-select v-model="value" clearable placeholder="请选择" :loading="isLoading" @visible-change="getDomainList">
                        <el-option v-for="item in options" :key="item.id" :label="item.domain" :value="item.id"></el-option>
                    </el-select> 专属域名稳定，专人专用，极大的避免微信红标。
                </div>



                <div><el-button type="primary" @click="startZh">生成短链接</el-button>
                    <span  v-if="newUrl" style="padding:10px;margin-left:20px;color:green;background:#eafbeb;border:1px solid #a9dcac;">转换成功！短链接为：{{newUrl}}</span>
                </div>


            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "ShortUrl",
        data() {

            return {
                orgUrl:"",
                newUrl:"",
                options: [],
                value: '',
                goodsTpl1:'',
                goodsData:{
                    title:'',
                    goods:[]
                },
                isLoad: false,
                isLoading: true,
            }
        },
        mounted() {
             var ccc=$('.goods_tpl_tpl').first().prop("outerHTML");
            this.goodsTpl1=ccc;
            window.getTbinfo=this.getTbinfo;
        },

        methods: {
            async getDomainList(val) {
                if (!val) return;
                if (this.isLoad) return;
                const {ret,msg,data} = await this.$api.exclusive.getUserList();
                if (ret === 1000){
                    this.isLoad = true;
                    this.isLoading = false;
                    this.options = data.list;
                }
            },
            async startZh() {
                var self=this;
                const id = this.value;

                self.goodsData={
                    title:'',
                        goods:[]
                };
                var title=$(".glist_title").val();
                self.goodsData.title=title;
                var i=0;
                var wrong=0;
                $('.glist_img').each(function(){
                    var tb_url=$(".glist_tb_url").eq(i).val();
                    var img_url=$(this).val();console.log(img_url);
                    var desc=$(".glist_desc").eq(i).val();
                    var kouling=$(".glist_kouling").eq(i).val();
                    var goods={
                        tb_url:tb_url,
                        goods_img:img_url,
                        goods_desc:desc,
                        kouling: kouling
                    }
                    if (!tb_url){
                        self.$message.error('链接不能为空');
                        wrong=1;
                        return;
                    }
                    if (!img_url){
                        self.$message.error('图片不能为空');
                        wrong=1;
                        return;
                    }
                    if (!desc){
                        self.$message.error('显示文字不能为空');
                        wrong=1;
                        return;
                    }
                    if (!kouling){
                        self.$message.error('口令不能为空');
                        wrong=1;
                        return;
                    }
                    self.goodsData.goods.push(goods);
                    i++;
                });
                if(wrong==1){
                    return;
                }

                if (!self.goodsData.title){
                    this.$message.error('请填写标题');
                    return;
                }
                if (!self.goodsData.goods.length){
                    this.$message.error('请填写商品信息');
                    return;
                }


                if (id === ''){
                    //this.$message.error('请选择专属域名!');
                    //return;
                }

                const postData = {
                    id: id,
                    goodsData:self.goodsData,
                };

                const {ret,msg,data} = await this.$api.exclusive.addGoodsLink(postData);
                if (ret === 1000){
                    this.$message.success('转换成功');
                    this.newUrl = data.url;
                }
            },
            addGoods() {
                var tpl1=$('.show22').first().prop("outerHTML");
                $('.show22_box').append(tpl1);

                $('.show22 .del_btn011').show();
                $('.del_btn011').first().hide();
                window.delGoods=this.delGoods;
                window.getTbinfo=this.getTbinfo;

            },
            delGoods(e) {
                console.log("hiii");
                console.log(e);
                $(e).parent().parent().remove();

            },

            async getTbinfo(e){
                var link=$(e).parent().find('.glist_tb_url').val();
                if(!link){
                    alert('请输入链接');
                    return false;
                }
                const postData = {
                    link: link
                };
                const {ret,msg,data} = await this.$api.exclusive.getTbInfo(postData);
                if (ret === 1000){
                    this.$message.success('转换成功');
                    console.log(data);
                    $(e).parent().parent().parent().find('.glist_img').val(data.goods_img);
                    $(e).parent().parent().parent().find('.glist_desc').html(data.copy_info);
                    //$(e).parent().parent().parent().find('.glist_kouling').val(data.goods_name);

                }
            },

            yulan(){
                self=this;
                var i=0;
                console.log(self.goodsTpl1);
                $('.goods_tpl_parent').html('');
                if($('.glist_title').val()==''){
                    alert('请输入标题');
                    return false;
                }
                var title=$(".glist_title").val();
                $('.goods_tpl_title').html(title);

                $('.glist_img').each(function(){console.log(i);
                    var img_url=$(this).val();console.log(img_url);
                    var desc=$(".glist_desc").eq(i).val();
                    var kouling=$(".glist_kouling").eq(i).val();
                    $('.goods_tpl_parent').append(self.goodsTpl1);
                    $('.goods_tpl_img_box img').eq(i).attr('src',img_url);
                    $('.goods_tpl_desc').eq(i).html(desc.replace(/[\n\r]/g,'<br>'));
                    $('.goods_tpl_kouling').eq(i).html(kouling);

                    i++;
                })


            },
            copyUrl() {
                const msg = this.$message;
                if (this.newUrl === ''){
                    msg.error('复制的内容为空！');
                    return;
                }
                this.$copyText(this.newUrl).then(function (e) {
                    msg.success('复制成功');
                }, function (e) {
                    msg.error('复制失败！');
                })
            },
            clearAll() {
                this.orgUrl = "";
                this.newUrl = "";
                this.$message.success('清除成功！');
            },
        },
    }
</script>
<style scoped>
    .bc-box{
        width: calc(100% - 40px);
        height:auto;
        padding: 20px;
        background:#fff;
    }
    .bc-box .bc-header{
        width: 100%;
        height: 40px;
    }
    .bc-box .bc-header .bc-title{
        display: inline-block;
        width: 120px;
        height: 40px;
        margin-right: 30px;
        font-size: 20px;
        line-height: 40px;
        vertical-align: top;
    }
    .bc-box .bc-header .bc-cont{
        display: inline-block;
        width: calc(100% - 150px);
        height: 100%;
        vertical-align: top;
    }
    .bc-box .bc-main{
        width: 100%;
        height: 885px;
        min-height: 755px;
        padding: 40px 110px;
    }
    .bc-box .bc-main .m-left,.bc-box .bc-main .m-right{
        display: inline-block;
        width: 360px;
        height: 100%;
        padding: 40px 0 180px 0;
        vertical-align: top;
        position: relative;
    }
    .bc-box .bc-main .m-mid{
        display: inline-block;
        width: 200px;
        height: 100%;
        padding: 40px 0 180px 0;
        vertical-align: top;
    }
    .bc-box .bc-main .m-mid .mid-btn-box{
        width: 100px;
        margin: 50px auto;
    }
    .m-left .tit,.m-right .tit{
        width: 100%;
        height: 30px;
        font-size: 16px;
        text-align: center;
        line-height: 30px;
        position: absolute;
        top: 0;
        left: 0;
    }
    .m-left .mid,.m-right .mid{
        width: 100%;
        height: 100%;
    }
    .m-left .mid textarea,.m-right .mid textarea{
        width: 100%;
        height: 100%;
        padding: 10px;
        border-radius: 4px;
        border: 1px solid #ccc;
        color: #333;
        line-height: 30px;
        resize: none;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .m-left .bot,.m-right .bot{
        width: 100%;
        height: 180px;
        padding-top: 10px;
        position: absolute;
        left: 0;
        bottom: 0;
    }
    .m-left .bot .bot-btn,.m-right .bot .bot-btn{
        width: 100%;
        margin-bottom: 10px;
    }
    .m-left .bot .tips,.m-right .bot .tips{
        width: 100%;
        height: 130px;
        padding-left: 15px;
        line-height: 30px;
    }
    .m-left .bot .tips h5,.m-right .bot .tips h5{
        color: #333333;
    }
    .m-left .bot .tips .desc,.m-right .bot .tips .desc {
        color: #666666;
        font-size: 14px;
    }
    .mb-10{
        margin-bottom: 10px;
    }

    .goods_tpl_box{height:680px;background: #eee; overflow: auto;}
    .goods_tpl_box .goods_tpl_title{background:#ed4c19;color:#fff;padding:7px;text-align: center;}
    .goods_tpl_box .goods_tpl_img_box{ padding:10px;text-align: center;}
    .goods_tpl_box .goods_tpl_img_box img{border-radius: 10px;border: 1px solid #f5f5f5;}
    .goods_tpl_box .goods_tpl_desc{ margin:0px 10px;border: 1px dashed #ed4c19;padding:20px; background: #fff;color:#333;font-size: 14px; text-align: center;}
    .copy-tip {
        display: flex;
        justify-content: space-around;
        align-items: center;
        background: linear-gradient(to right, #f9c492, #fb6a65);
        color: white;
        font-size: 12px;
        height: 24px;
    }
    .jtone {
        position: relative;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-left: 10px solid white;
        border-bottom: 12px solid transparent;
    }
    .jtone::before {
        content: "";
        position: absolute;
        top: -12px;
        left: -13px;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-left: 10px solid #fab189;
        border-bottom: 12px solid transparent;
    }
    .jttwo {
        position: relative;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-left: 10px solid white;
        border-bottom: 12px solid transparent;
    }
    .jttwo::before {
        content: "";
        position: absolute;
        top: -12px;
        left: -13px;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-left: 10px solid #fa9b7e;
        border-bottom: 12px solid transparent;
    }
    .jtthree {
        position: relative;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-left: 10px solid white;
        border-bottom: 12px solid transparent;
    }
    .jtthree::before {
        content: "";
        position: absolute;
        top: -12px;
        left: -13px;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-left: 10px solid #fa8673;
        border-bottom: 12px solid transparent;
    }
    .icopy {
        /*background: #fb6a65;*/
        /*background: linear-gradient(120deg, rgb(255,78,64), rgb(255,113,61));*/
        background: linear-gradient(20deg, rgb(255,69,60), rgb(255,91,51));
        border-radius: 5px;
        color: white;
        font-size: 14px;
        margin: 16px auto;
        padding: 10px;
        margin-bottom: 2px;
        cursor:pointer;
        text-align: center;
    }
    .icopy_ {
        background: #acb4bc;
        border-radius: 0.3125rem;
        color: white;
        font-size: 0.875rem;
        margin: 1rem auto;
        padding: 0.625rem;
        padding: 0.625rem;
        cursor: pointer;
        margin-bottom: 0rem;
    }
    .icopy_:hover{
        background: #bdc5cd;
    }
</style>
